import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

export function createIdempotencyKey(prefix = 'mutation') {
  const scope = String(prefix || 'mutation')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'mutation';

  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${scope}-${crypto.randomUUID()}`;
  }

  return `${scope}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function withIdempotencyKey(prefix) {
  return {
    fetchOptions: {
      headers: resolveAuthenticatedHeaders({
        'x-idempotency-key': createIdempotencyKey(prefix),
      }),
    },
  };
}
